import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LoginSchema = withDefaults({
  type: 'login',
  objectExtensions: ['login'],
  fields: [
    {
      kind: 'attribute',
      name: 'userName',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'twoFactorEnabled',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default LoginSchema;
